import React, { useEffect, useState } from 'react';

const ContactPage = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 


  const [form, setForm] = useState({ name:'', email:'', company:'', message:'' });
  const [submitting, setSubmitting] = useState(false);

  const offices = [
    { city:'Bhopal', address:['257, M.P. Nagar','Zone‑2, 462001'], phone:'+91 94257-56634' },
    { city:'Remote', address:['Global Availability'], phone:'—' },
  ];

  const faqs = [
    { q:'How soon can you start?', a:'Typically within 1–2 weeks depending on scope.' },
    { q:'Do you work with startups?', a:'Yes, from MVPs to growth-stage scaleups.' },
    { q:'What engagement models?', a:'Fixed scope, time & material, or dedicated squads.' },
  ];

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setTimeout(() => { setSubmitting(false); setForm({ name:'', email:'', company:'', message:'' }); alert('Thanks! We will get back to you.'); }, 600);
  };

  return (
    <main className="pt-20 bg-white dark:bg-gray-900 min-h-screen">
      {/* Hero */}
      <section>
        <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white">Let’s Talk</h1>
          <p className="mt-3 md:text-lg text-gray-600 dark:text-gray-300 max-w-3xl">Share a bit about your goals and we’ll suggest the best path forward.</p>
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </section>

      {/* Form + Info */}
      <section className="py-12 bg-blue-50 dark:bg-gray-900 md:py-16">
        <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-8">
          {/* Form */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 md:p-8 shadow border border-gray-200 dark:border-gray-700">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">Start a project</h2>
            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">Full Name</label>
                <input name="name" value={form.name} onChange={onChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white" placeholder="Jane Doe" />
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">Email</label>
                  <input type="email" name="email" value={form.email} onChange={onChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white" placeholder="you@company.com" />
                </div>
                <div>
                  <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">Company</label>
                  <input name="company" value={form.company} onChange={onChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white" placeholder="Company Inc." />
                </div>
              </div>
              <div>
                <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">How can we help?</label>
                <textarea rows={4} name="message" value={form.message} onChange={onChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white" placeholder="Tell us about your project, timeline, and goals" />
              </div>
              <button disabled={submitting} className="w-full bg-[#0284c7] hover:bg-[#0271a3] text-white px-6 py-3 rounded-lg font-semibold transition">{submitting ? 'Sending…' : 'Send message'}</button>
            </form>
          </div>

          {/* Info */}
          <div className="space-y-8">
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow">
              <h3 className="font-semibold text-gray-900 dark:text-white">Offices</h3>
              <div className="mt-4 grid sm:grid-cols-2 gap-4">
                {offices.map((o, i) => (
                  <div key={i} className="p-4 rounded-xl bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700">
                    <div className="text-sm font-semibold text-[#0284c7]">{o.city}</div>
                    <div className="text-sm text-gray-600 dark:text-gray-300">{o.address.join(', ')}</div>
                    <div className="text-sm text-gray-600 dark:text-gray-300">{o.phone}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow">
              <h3 className="font-semibold text-gray-900 dark:text-white">FAQs</h3>
              <div className="mt-4 space-y-4">
                {faqs.map((f, i) => (
                  <details key={i} className="rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 p-4">
                    <summary className="cursor-pointer font-medium text-gray-900 dark:text-white">{f.q}</summary>
                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{f.a}</p>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;


